import { render, staticRenderFns } from "./OrganizationEdit.vue?vue&type=template&id=5623047e&scoped=true&"
import script from "./OrganizationEdit.vue?vue&type=script&lang=js&"
export * from "./OrganizationEdit.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationEdit.vue?vue&type=style&index=0&id=5623047e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5623047e",
  null
  
)

export default component.exports